import React, { useState } from 'react';
import { isFunction } from 'lodash';
import UI from '../ui';
import ModalModule from '../modal';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedColorPickerWithLabel, WrappedInputTextWithLabel } = UI;

const EditTagModal = ({ modalId, data = {} }) => {
	const { selectTag = {}, tagOptions, type, onSaveTagCallback } = data;
	const { Tag = '', Color = '#ff0000', OrderTagID = '' } = selectTag;
	const [tagName, setTagName] = useState(Tag);
	const [tagColor, setTagColor] = useState(Color);
	const [validation, setValidation] = useState({
		isValid: null,
		errorMessage: '',
	});

	const validate = () => {
		const newValidation = { ...validation };

		if (tagName === '') {
			newValidation.isValid = false;
			newValidation.errorMessage = 'Tag name required.';
		}
		// WEBAPPS-27402, check duplicate tag names (exclude current selecting tag)
		else if (
			tagOptions.some(
				option =>
					option.Tag.toLowerCase() === tagName.toLowerCase() &&
					option.OrderTagID !== OrderTagID
			)
		) {
			newValidation.isValid = false;
			newValidation.errorMessage = `There is already another tag named ${tagName}`;
		} else {
			newValidation.isValid = true;
			newValidation.errorMessage = '';
		}

		setValidation(newValidation);

		return newValidation.isValid;
	};

	const onSaveTag = closeModal => {
		if (validate()) {
			if (isFunction(onSaveTagCallback)) {
				onSaveTagCallback({ tagName, tagColor });
			}
			closeModal();
		}
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Save',
		onClick: onSaveTag,
		dataqa: 'edit-tag-save-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="common-tags edit-tag-modal"
			header={`${type} Tag`}
			primaryButton={primaryButton}
			size="small"
		>
			<WrappedInputTextWithLabel
				label="Tag Name"
				errorMessage={validation.errorMessage}
				isInputInvalid={validation.isValid === false}
				uiElementConfig={{
					dataqa: 'tag-name',
					value: tagName,
					onBlur: validate,
					onChange: ({ target: { value } }) => setTagName(value),
				}}
			/>
			<div>
				<WrappedColorPickerWithLabel
					label="Tag Color"
					uiElementConfig={{
						dataqa: 'tag-color',
						value: tagColor,
						appendTo: document.body,
						onChange: ({ target: { value } }) => setTagColor(`#${value}`),
					}}
				/>
			</div>
		</Modal>
	);
};

export default EditTagModal;
